import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import AddressForm from "./AddressForm";

const Shipping = ({ values, setOrderData }) => {
  return (
    <Box m="30px auto">
      {/* BILLING FORM */}
      <Box>
        <Typography sx={{ mb: "15px" }} fontSize="18px">
          Billing Information
        </Typography>
        <AddressForm
          type="billingAddress"
          values={values}
          // handleChange={handleChange}
          setOrderData={setOrderData}
        />
      </Box>

      <Box mb="20px">
        <FormControlLabel
          control={
            <Checkbox
              defaultChecked
              value={values.shippingAddress.isSameAddress}
              onChange={() =>
                setOrderData({
                  ...values,
                  billingAddress: {
                    ...values.billingAddress,
                  },
                  shippingAddress: {
                    ...values.shippingAddress,
                    isSameAddress: !values.shippingAddress.isSameAddress,
                  },
                })
              }
            />
          }
          label="Same for Shipping Address"
        />
      </Box>

      {/* SHIPPING FORM */}
      {!values.shippingAddress.isSameAddress && (
        <Box>
          <Typography sx={{ mb: "15px" }} fontSize="18px">
            Shipping Information
          </Typography>
          <AddressForm
            type="shippingAddress"
            values={values}
            // handleChange={handleChange}
            setOrderData={setOrderData}
          />
        </Box>
      )}
    </Box>
  );
};

export default Shipping;
